import React, { Component } from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";
import uuidv4 from "uuid/v4";
import PropTypes from "prop-types";
import { Button, Icon, Message, Modal, Segment } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import moment from "moment";
import UiMeet3dLinkStore from "~/stores/UiMeet3d/UiMeet3dLinkStore";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import UiMeet3dLinkPairs from "~/modules/UiMeet3d/components/UiMeet3dLinkPairs";
import ToastMessageStore from "~/stores/ToastMessageStore";
import FormStore from "~/stores/FormStore";
import ProviderStore from "~/stores/Provider/ProviderStore";
import CustomerStore from "~/stores/CustomerStore";
import UiMeet3dLinkPairStore from "~/stores/UiMeet3d/UiMeet3dLinkPairStore";
import UiMeet3dLinkPairForm from "~/modules/UiMeet3d/components/UiMeet3dLinkPairForm";

@observer
class UiMeet3dLinkSegment extends Component {
  @observable uiMeet3dLinkStore = null;

  @observable uiMeet3dLinkPairStore = null;

  @observable formStore = null;

  constructor(props) {
    super(props);

    this.uiMeet3dLinkStore = new UiMeet3dLinkStore();
    this.uiMeet3dLinkPairStore = new UiMeet3dLinkPairStore();
    this.formStore = new FormStore();

    this.state = {
      uiMeet3dLinkFormModalVisible: false,
      uiMeet3dLinkPairIndex: null,
      uiMeet3dLinkPairRoomId: null,
    };

    this.formStore = new FormStore({
      name: "",
      email: "",
      usePhotos: true,
      isGuidedTourMode: false,
      uiMeet3dLinkPhotoData: "",
      deleteUiMeet3dLinkPhoto: false,
      uiMeet3dLinkLogoData: "",
      deleteUiMeet3dLinkLogo: false,
      activationDts: "",
      expirationDts: "",
    });
  }

  componentDidMount() {
    const { tourId, showError, actualUserStore } = this.props;
    const { actualUser } = actualUserStore;

    this.uiMeet3dLinkStore.searchParams.tourId = tourId;

    this.uiMeet3dLinkStore.loadIndex().catch(error => showError(error.message));

    this.bindForm(actualUser);
  }

  showUiMeet3dLinkFormModal = (
    uiMeet3dLinkPairIndex,
    uiMeet3dLinkPairRoomId,
    uiMeet3dLinkPhotoPathWeb,
    uiMeet3dLinkLogoPathWeb,
    uiMeet3dLink,
  ) => {
    const { actualUserStore } = this.props;
    const { actualUser } = actualUserStore;

    this.bindForm(actualUser, uiMeet3dLink);

    const newStateData = {
      uiMeet3dLinkFormModalVisible: true,
      uiMeet3dLinkPairIndex: null,
      uiMeet3dLinkPairRoomId: null,
      uiMeet3dLinkPhotoPathWeb: null,
      uiMeet3dLinkLogoPathWeb: null,
    };

    if (typeof uiMeet3dLinkPairIndex !== "undefined") {
      newStateData.uiMeet3dLinkPairIndex = uiMeet3dLinkPairIndex;
    }

    if (typeof uiMeet3dLinkPairRoomId !== "undefined") {
      newStateData.uiMeet3dLinkPairRoomId = uiMeet3dLinkPairRoomId;
    }

    if (typeof uiMeet3dLinkPhotoPathWeb !== "undefined") {
      newStateData.uiMeet3dLinkPhotoPathWeb = uiMeet3dLinkPhotoPathWeb;
    }

    if (typeof uiMeet3dLinkLogoPathWeb !== "undefined") {
      newStateData.uiMeet3dLinkLogoPathWeb = uiMeet3dLinkLogoPathWeb;
    }

    this.setState(newStateData);
  };

  hideUiMeet3dLinkFormModal = () =>
    this.setState({ uiMeet3dLinkFormModalVisible: false, uiMeet3dLinkPairIndex: null, uiMeet3dLinkPairRoomId: null });

  convertDateToTimestamp = value => {
    return moment(value).unix();
  };

  convertTimestampToDate = date => {
    if (!date) {
      return date;
    }

    return date.format(moment.HTML5_FMT.DATETIME_LOCAL);
  };

  bindForm(actualUser, uiMeet3dLink) {
    const uiMeet3dLinkExists = typeof uiMeet3dLink !== "undefined";

    let name = "";

    // Provider
    if (uiMeet3dLinkExists) {
      name = uiMeet3dLink.name;
    } else if (typeof actualUser.name !== "undefined") {
      name = actualUser.name;
    }
    // Customer
    else if (typeof actualUser.firstName !== "undefined" && typeof actualUser.lastName !== "undefined") {
      name = `${actualUser.firstName} ${actualUser.lastName}`;
    }

    const initialModel = {
      name,
      email: uiMeet3dLinkExists ? uiMeet3dLink.email : actualUser.email,
      usePhotos: uiMeet3dLinkExists ? uiMeet3dLink.usePhotos : true,
      isGuidedTourMode: uiMeet3dLinkExists ? uiMeet3dLink.isGuidedTourMode : false,
      uiMeet3dLinkPhotoData: "",
      deleteUiMeet3dLinkPhoto: false,
      uiMeet3dLinkLogoData: "",
      deleteUiMeet3dLinkLogo: false,
      activationDts:
        uiMeet3dLinkExists && uiMeet3dLink.activationDts ? this.convertTimestampToDate(uiMeet3dLink.activationDts) : "",
      expirationDts:
        uiMeet3dLinkExists && uiMeet3dLink.expirationDts ? this.convertTimestampToDate(uiMeet3dLink.expirationDts) : "",
    };

    this.formStore = new FormStore(initialModel);
  }

  createUiMeet3dLinkPair() {
    const { tourId, showError, toastMessageStore, t, actualUserStore } = this.props;
    const { model } = this.formStore;

    const newRoomId = uuidv4();

    const uiMeet3dLinkPairData = {
      tourId,
      roomId: newRoomId,
      name: model.name !== "" ? model.name : null,
      email: model.email !== "" ? model.email : null,
      usePhotos: model.usePhotos,
      isGuidedTourMode: model.isGuidedTourMode,
      activationDts:
        model.activationDts && model.activationDts !== "" ? this.convertDateToTimestamp(model.activationDts) : null,
      expirationDts:
        model.expirationDts && model.expirationDts !== "" ? this.convertDateToTimestamp(model.expirationDts) : null,
    };

    if (model.deleteUiMeet3dLinkPhoto) {
      uiMeet3dLinkPairData.photoUrl = null;
    } else if (model.uiMeet3dLinkPhotoData) {
      uiMeet3dLinkPairData.photoData = model.uiMeet3dLinkPhotoData;
    }

    if (model.deleteUiMeet3dLinkLogo) {
      uiMeet3dLinkPairData.logoUrl = null;
    } else if (model.uiMeet3dLinkLogoData) {
      uiMeet3dLinkPairData.logoData = model.uiMeet3dLinkLogoData;
    }

    return this.uiMeet3dLinkPairStore
      .create(uiMeet3dLinkPairData)
      .then(() => {
        this.uiMeet3dLinkStore.loadIndex().catch(error => showError(error.message));
        toastMessageStore.addToastMessage(t("changesSaved"), "positive", t("success"));

        const { actualUser } = actualUserStore;
        this.bindForm(actualUser);
      })
      .catch(error => {
        if (error.status === "error") {
          showError(error.message);
        }

        throw error;
      });
  }

  updateUiMeet3dLinkPair(roomId) {
    const { showError, toastMessageStore, t } = this.props;
    const { model } = this.formStore;

    const uiMeet3dLinkPairData = {
      name: model.name !== "" ? model.name : null,
      email: model.email !== "" ? model.email : null,
      usePhotos: model.usePhotos,
      isGuidedTourMode: model.isGuidedTourMode,
      activationDts:
        model.activationDts && model.activationDts !== "" ? this.convertDateToTimestamp(model.activationDts) : null,
      expirationDts:
        model.expirationDts && model.expirationDts !== "" ? this.convertDateToTimestamp(model.expirationDts) : null,
    };

    if (model.deleteUiMeet3dLinkPhoto) {
      uiMeet3dLinkPairData.photoUrl = null;
    } else if (model.uiMeet3dLinkPhotoData) {
      uiMeet3dLinkPairData.photoData = model.uiMeet3dLinkPhotoData;
    }

    if (model.deleteUiMeet3dLinkLogo) {
      uiMeet3dLinkPairData.logoUrl = null;
    } else if (model.uiMeet3dLinkLogoData) {
      uiMeet3dLinkPairData.logoData = model.uiMeet3dLinkLogoData;
    }

    return this.uiMeet3dLinkPairStore
      .update(roomId, uiMeet3dLinkPairData)
      .then(() => {
        this.uiMeet3dLinkStore.loadIndex().catch(error => showError(error.message));
        toastMessageStore.addToastMessage(t("changesSaved"), "positive", t("success"));
      })
      .catch(error => {
        if (error.status === "error") {
          showError(error.message);
        }

        throw error;
      });
  }

  deleteUiMeet3dLinkPair(roomId) {
    const { showError, toastMessageStore, t } = this.props;

    this.uiMeet3dLinkPairStore
      .delete(roomId)
      .then(() => {
        this.uiMeet3dLinkStore.loadIndex().catch(error => showError(error.message));
        toastMessageStore.addToastMessage(t("clientPanelMisc:uiMeet3dGeneratedLinkDeleted"), "positive", t("success"));
      })
      .catch(error => {
        if (error.status === "error") {
          showError(error.message);
        }
      });
  }

  render() {
    const { errorMessages, isSaving } = this.uiMeet3dLinkPairStore;
    const { uiMeet3dLinks, isLoading } = this.uiMeet3dLinkStore;
    const { actualUserStore, t } = this.props;
    const {
      uiMeet3dLinkFormModalVisible,
      uiMeet3dLinkPairIndex,
      uiMeet3dLinkPairRoomId,
      uiMeet3dLinkPhotoPathWeb,
      uiMeet3dLinkLogoPathWeb,
    } = this.state;
    const { actualUser } = actualUserStore;
    const { isDirty } = this.formStore;

    let defaultPhotoPathWeb = null;

    if (actualUser.photoUrl !== "undefined" && actualUser.photoUrl !== null) {
      defaultPhotoPathWeb = actualUser.photoPathWeb;
    }

    let defaultLogoPathWeb = null;

    if (actualUser.logoUrl !== "undefined" && actualUser.logoUrl !== null) {
      defaultLogoPathWeb = actualUser.logoPathWeb;
    }

    return (
      <>
        <Segment style={{ marginTop: "1rem" }}>
          <h3>{t("clientPanelMisc:uiMeet3dGeneratedLinks")}</h3>
          <Message info>
            <Message.Header>{t("clientPanelMisc:whatIsAnUiMeet3dGeneratedLink")}</Message.Header>
            <p>{t("clientPanelMisc:uiMeet3dGeneratedLinkDescription")}</p>
            <Message.List>
              <Message.Item>{t("clientPanelMisc:uiMeet3dOrganizerLinkDescription")}</Message.Item>
              <Message.Item>{t("clientPanelMisc:uiMeet3dVisitorLinkDescription")}</Message.Item>
            </Message.List>
            <p>{t("clientPanelMisc:uiMeet3dGeneratedLinksNotes")}</p>
            <Button primary onClick={() => this.showUiMeet3dLinkFormModal()}>
              {t("clientPanelMisc:createAnUiMeet3dLink")}
            </Button>
          </Message>
          <UiMeet3dLinkPairs
            uiMeet3dLinks={uiMeet3dLinks}
            isLoading={isLoading}
            deleteUiMeet3dLinkPairCallback={roomId => this.deleteUiMeet3dLinkPair(roomId)}
            showUiMeet3dLinkFormModalCallback={(index, roomId, photoPathWeb, logoPathWeb, uiMeet3dLink) =>
              this.showUiMeet3dLinkFormModal(index, roomId, photoPathWeb, logoPathWeb, uiMeet3dLink)
            }
            defaultPhotoPathWeb={defaultPhotoPathWeb}
            defaultLogoPathWeb={defaultLogoPathWeb}
          />
        </Segment>
        <Modal open={uiMeet3dLinkFormModalVisible} onClose={() => this.hideUiMeet3dLinkFormModal()}>
          <Modal.Header>
            {uiMeet3dLinkPairIndex
              ? t("clientPanelMisc:updateUiMeet3dLinkWithIndex", { index: uiMeet3dLinkPairIndex })
              : t("clientPanelMisc:createAnUiMeet3dLink")}
          </Modal.Header>
          <Modal.Content>
            <UiMeet3dLinkPairForm
              formStore={this.formStore}
              validationErrors={typeof errorMessages === "object" ? errorMessages : null}
              isSaving={isSaving}
              defaultPhotoPathWeb={defaultPhotoPathWeb}
              defaultLogoPathWeb={defaultLogoPathWeb}
              uiMeet3dLinkPhotoPathWeb={uiMeet3dLinkPhotoPathWeb}
              uiMeet3dLinkLogoPathWeb={uiMeet3dLinkLogoPathWeb}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button secondary onClick={() => this.hideUiMeet3dLinkFormModal()}>
              {t("cancel")}
            </Button>
            {uiMeet3dLinkPairRoomId ? (
              <Button
                primary
                onClick={() => {
                  this.updateUiMeet3dLinkPair(uiMeet3dLinkPairRoomId).then(() => {
                    this.hideUiMeet3dLinkFormModal();
                  });
                }}
                disabled={!isDirty}
              >
                <Icon name="save" />
                &nbsp;{t("save")}
              </Button>
            ) : (
              <Button
                primary
                onClick={() => {
                  this.createUiMeet3dLinkPair().then(() => {
                    this.hideUiMeet3dLinkFormModal();
                  });
                }}
              >
                {t("create")}
              </Button>
            )}
          </Modal.Actions>
        </Modal>
      </>
    );
  }
}

UiMeet3dLinkSegment.propTypes = {
  t: PropTypes.func.isRequired,
  tourId: PropTypes.number.isRequired,
  toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
  actualUserStore: PropTypes.oneOfType([PropTypes.instanceOf(ProviderStore), PropTypes.instanceOf(CustomerStore)]),
};

export default withTranslation()(ErrorWrapper(UiMeet3dLinkSegment));
